import React from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { replyYopValidation } from './validation';
import validate from '../../../../utils/validate';
import RepliesFormInner from './RepliesFormInner';

function RepliesForm({ onReply }) {
  const { id } = useParams();
  const dispatch = useDispatch();

  const generationForm = useSelector((state) => state.id8.generationForm);

  const repliesFormInitialValues = {
    hint: generationForm.hint,
    reply: '',
  };

  const handleReplies = (values) => {
    dispatch(onReply({ id, reply: values.reply }));
  };

  return (
    <Form
      initialValues={repliesFormInitialValues}
      onSubmit={handleReplies}
      subscription={{ submitting: true, pristine: true }}
      validateOnBlur={false}
      validate={(values) => validate(values, replyYopValidation())}
      render={({ handleSubmit }) => <RepliesFormInner onSubmit={handleSubmit} />}
    />
  );
}

export default RepliesForm;
